import { logError, logInfo } from 'owa-groups-adaptors';

export class GroupsCommonErrorType {
    static GetUnifiedGroupDetailsError = 'GUD';
    static GetUnifiedGroupMembersError = 'GUM';
}

export class GroupsHubErrorType {
    static DismissGroupSuggestion = 'DGS';
    static JoinGroupError = 'JGE';
    static LoadGroupsError = 'LG';
    static LoadSuggestedGroupsError = 'LSG';
    static LoadOrgGroupsError = 'LOG';
    static UpgradeDistributionGroupError = 'UDG';
}

export class GroupsHubInfoType {
    static PivotClicked = 'PIVT';
    static FilterChanged = 'FILT';
    static EditCardInvoked = 'ECI';
    static AddMemberCardInvoked = 'ACI';
    static SortOrderChanged = 'SOC';
    static LoadMoreButtonClicked = 'LMC';
}

export class GroupsHubCommonLogKeys {
    static TestKey = 'TEST';
    static ContextKey = 'CTX';
    static ErrorMessageKey = 'ERR';
}

export class CreateGroupErrorType {
    static ValidateGroupPropertiesError = 'VGP';
    static CreateUnifiedGroupError = 'CUG';
}

export class GroupHeaderErrorType {
    static JoinGroupError = 'JGE';
    static LeaveGroupError = 'LGE';
    static RequestToJoinGroupError = 'RJGE';
    static SetGroupSubscriptionError = 'SGS';
}

export class GroupsDiscoverInfoType {
    static FilterChanged = 'FLTC';
    static FilterCleared = 'FLTX';
    static LoadMoreButtonClicked = 'LMC';
}

export class GroupsDiscoverErrorType {
    static DismissGroupSuggestion = 'DGS';
    static JoinGroupError = 'JGE';
    static LoadSuggestedGroupsError = 'LSG';
    static SearchOrgGroupsError = 'SOG';
}

export var LogError = (errorCode: string, context: string, errorMessage: string) => {
    if (context.indexOf(GroupsHubCommonLogKeys.TestKey) >= 0) {
        return;
    }

    if (logError) {
        logError(errorCode, [
            GroupsHubCommonLogKeys.ContextKey,
            context,
            GroupsHubCommonLogKeys.ErrorMessageKey,
            errorMessage,
        ]);
    }
};

export var LogInfo = (infoCode: string, context: string, metadata?: string[]) => {
    if (context.indexOf(GroupsHubCommonLogKeys.TestKey) >= 0) {
        return;
    }

    let contextualizedMetadata: string[] = [GroupsHubCommonLogKeys.ContextKey, context];
    if (metadata) {
        contextualizedMetadata.concat(metadata);
    }

    if (logInfo) {
        logInfo(infoCode, contextualizedMetadata);
    }
};
